(function(){
var root=document.getElementById('coCreditCheck'); if(!root)return;
var screens=[].slice.call(root.querySelectorAll('.co-cpc-screen'));
var byName={}; screens.forEach(function(s){byName[s.getAttribute('data-screen')]=s;});
var answers={}, flow=[], idx=0, screenStartedAt=Date.now(), startedAt=Date.now(), resultData={}, customerData={}, orderData={}, stripe=null,elements=null,paymentElement=null,checkoutInitialized=false;
var PAYMENT_INTENT_URL='https://credit-optimize-backend-v2.vercel.app/api/create-payment-intent';
var STRIPE_PUBLIC_KEY='pk_live_51TGimICdbuuOhlEsdxuYXzRlCYRjPDvOL6pzsv767SdzSxo65upq3YN0grhnwROZ002UZiBXzCtKvGifmORUJPmS00caNsFQ9u';
var SUCCESS_URL=window.location.origin+'/pages/secure-upload';
function qs(sel){return root.querySelector(sel)}
function flowQuestions(){var f=['goal']; if(answers.goal==='mortgage') f.push('mortgage_amount'); if(answers.goal==='auto') f.push('auto_amount'); f.push('utilization','industry_late','lates','collections','profile'); return f;}
function buildFlow(){flow=flowQuestions().concat(['analyzing','result','checkout','success']);}
function current(){return flow[idx];}
function questionCount(){return flowQuestions().length;}
function qIndex(){return Math.min(idx+1,questionCount());}
function track(name,extra){try{var payload=Object.assign({funnel:'Credit Report Clarity Funnel',product:'Credit Report Clarity Check',version:'CRC v4',page_path:location.pathname,page_url:location.href,goal:answers.goal||'',answers:JSON.stringify(answers)},extra||{}); if(window.mixpanel&&mixpanel.track)mixpanel.track(name,payload); if(window.gtag)gtag('event',name.toLowerCase().replace(/[^a-z0-9]+/g,'_'),payload); window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:name.toLowerCase().replace(/[^a-z0-9]+/g,'_')},payload));}catch(e){}}
function setIndustryCopy(){
var g=answers.goal||'';
var kicker='Payment history';
var frame='Payment-history information is one category commonly displayed on credit reports.';
var q='Have you had any account reported more than 30 days late in the last 12 months?';
var h='This helps organize the payment-history information you entered.';
if(g==='mortgage'){
  kicker='Mortgage payment history';
  frame='Because you selected mortgage, this question asks specifically about mortgage payment history.';
  q='Have you had a mortgage payment reported more than 30 days late in the last 12 months?';
  h='This response will appear in your preliminary educational summary.';
}
if(g==='auto'){
  kicker='Auto loan payment history';
  frame='Because you selected auto financing, this question asks specifically about auto-loan payment history.';
  q='Have you had an auto loan payment reported more than 30 days late in the last 12 months?';
  h='This response will appear in your preliminary educational summary.';
}
qs('#coCpcIndustryKicker').textContent=kicker;
qs('#coCpcIndustryFrame').textContent=frame;
qs('#coCpcIndustryQuestion').textContent=q;
qs('#coCpcIndustryHelp').textContent=h;
}
function show(){buildFlow(); screens.forEach(function(s){s.classList.remove('is-active')}); var name=current(); byName[name].classList.add('is-active'); screenStartedAt=Date.now(); setIndustryCopy(); var isQ=idx<questionCount(); qs('#coCpcStepLabel').textContent=isQ?('Question '+qIndex()+' of '+questionCount()):(name==='success'?'Complete':''); qs('#coCpcProgressFill').style.width=isQ?((qIndex()/questionCount())*100)+'%':'100%'; qs('[data-cpc-back]').style.visibility=idx===0?'hidden':'visible'; qs('[data-cpc-next]').style.display='none'; try{root.scrollIntoView({behavior:'smooth',block:'start'});}catch(e){} }
function goNext(){ if(idx<flow.length-1){ idx++; if(current()==='analyzing') analyze(); else show(); } }
function goBack(){ if(idx>0){idx--; show(); track('CRC v4 - Back Clicked',{screen:current()});} }
function pressureScore(){var s=0,u=answers.utilization;if(u==='75plus')s+=38;else if(u==='50_74')s+=28;else if(u==='30_49')s+=15;else if(u==='unknown')s+=12;if(answers.industry_late==='yes'){ if(answers.goal==='mortgage')s+=42; else if(answers.goal==='auto')s+=34; else if(answers.goal==='credit_card')s+=28; else s+=24;}var l=answers.lates;if(l==='recent_12')s+=25;else if(l==='three_plus')s+=22;else if(l==='two')s+=14;else if(l==='one')s+=8;var c=answers.collections;if(c==='multiple_active')s+=34;else if(c==='one_active')s+=26;else if(c==='paid')s+=9;else if(c==='unknown')s+=12;var p=answers.profile;if(p==='thin')s+=22;else if(p==='under5')s+=14;else if(p==='cards_only')s+=10;return Math.min(100,s);}
function rating(score){ if(score>=75)return 'High Impact'; if(score>=52)return 'Needs Attention'; if(score>=28)return 'Moderate'; if(score<12)return 'Strong'; return 'Low'; }
function payment(principal,rate,months){var r=rate/100/12; if(!principal||!r||!months)return 0; return principal*r*Math.pow(1+r,months)/(Math.pow(1+r,months)-1);}
function autoImpact(score){var amounts={under20:15000,'20_35':27500,'35_50':42500,'50plus':60000,unknown:35000};var amount=amounts[answers.auto_amount||'unknown']||35000;var current=score>=52?16.01:score>=28?9.57:score>=12?6.27:5.27;var base=5.27;var diff=Math.max(0,payment(amount,current,72)-payment(amount,base,72));var low=Math.max(0,Math.round(diff*.75));var high=Math.max(low+20,Math.round(diff*1.15+20));return{amount:amount,currentRate:current,low:low,high:high,tier:score>=52?'Subprime':score>=28?'Near Prime':score>=12?'Prime':'Super Prime'};}
function mortgageImpact(score){
var amounts={
under200:175000,
'200_350':275000,
'350_500':425000,
'500_750':625000,
'750_1000':875000,
'1000plus':1250000,
unknown:400000
};
var loan=amounts[answers.mortgage_amount||'unknown']||400000;
var baseRate=6.75;
var lowSpread=0;
var highSpread=.25;

if(score>=75){lowSpread=1.25;highSpread=2.00;}
else if(score>=52){lowSpread=.75;highSpread=1.25;}
else if(score>=28){lowSpread=.35;highSpread=.75;}
else if(score>=12){lowSpread=.10;highSpread=.35;}

var basePayment=payment(loan,baseRate,360);
var lowPayment=payment(loan,baseRate+lowSpread,360);
var highPayment=payment(loan,baseRate+highSpread,360);

var low=Math.max(0,Math.round(lowPayment-basePayment));
var high=Math.max(low,Math.round(highPayment-basePayment));

return{
loan:loan,
baseRate:baseRate,
lowRate:baseRate+lowSpread,
highRate:baseRate+highSpread,
low:low,
high:high
};
}
function buildResult(){
var s=pressureScore(), g=answers.goal||'not_sure';
resultData={score:s,goal:g};

function utilizationText(v){
  return {under10:'Under 10% selected','10_29':'10–29% selected','30_49':'30–49% selected','50_74':'50–74% selected','75plus':'75%+ selected',unknown:'Not sure'}[v]||'Not provided';
}
function paymentText(v){
  return {no:'No recent late reported',yes:'Recent late reported',not_applicable:'No applicable account',unknown:'Not sure'}[v]||'Not provided';
}
function collectionText(v){
  return {none:'None reported',paid:'Paid collection(s) reported',one_active:'One active collection reported',multiple_active:'Multiple active collections reported',unknown:'Not sure'}[v]||'Not provided';
}
function profileText(v){
  return {strong_10:'10+ years / strong mix','decent_5_10':'5–10 years / decent mix',under5:'Under 5 years','cards_only':'Mostly credit cards','thin':'Thin or limited history',unknown:'Not sure'}[v]||'Not provided';
}

qs('#coCpcResultTitle').textContent='Your Credit Report Clarity Snapshot';
qs('#coCpcResultIntro').textContent='Based on the information you entered, several categories of credit-report information may be relevant to what you are seeing.';
qs('#coCpcBalanceSummary').textContent=utilizationText(answers.utilization);
qs('#coCpcPaymentSummary').textContent=paymentText(answers.industry_late);
qs('#coCpcCollectionSummary').textContent=collectionText(answers.collections);
qs('#coCpcProfileSummary').textContent=profileText(answers.profile);

if(g==='mortgage'){
  qs('#coCpcPaidCopy').textContent='Submit the credit reports you want reviewed and receive a clear explanation of the accounts, balances, payment history, collections, and bureau differences shown — including mortgage-related reporting where present.';
}else if(g==='auto'){
  qs('#coCpcPaidCopy').textContent='Submit the credit reports you want reviewed and receive a clear explanation of the accounts, balances, payment history, collections, and bureau differences shown — including auto-loan reporting where present.';
}else{
  qs('#coCpcPaidCopy').textContent='Submit the credit reports you want reviewed and receive a clear, organized explanation of the information appearing on them.';
}
track('CRC v4 - Snapshot Viewed',resultData);
}
function analyze(){show(); var line=qs('#coCpcAnalyzeCostLine'); line.textContent=(answers.goal==='mortgage')?'Reviewing mortgage-related responses':(answers.goal==='auto'?'Reviewing auto-related responses':'Reviewing balance and account information');[].slice.call(root.querySelectorAll('#coCpcAnalyzeList li')).forEach(function(li,i){li.classList.remove('is-done');setTimeout(function(){li.classList.add('is-done');li.textContent='✓ '+li.textContent.replace(/^✓ /,'');},350+i*450)});setTimeout(function(){idx=flow.indexOf('result');buildResult();show();},1900);}
root.querySelectorAll('.co-cpc-options button').forEach(function(btn){btn.addEventListener('click',function(){var box=btn.closest('.co-cpc-options'),key=box.getAttribute('data-key');[].slice.call(box.children).forEach(function(b){b.classList.remove('is-selected')});btn.classList.add('is-selected');answers[key]=btn.getAttribute('data-value');track('CRC v4 - Question Answered',{question_key:key,answer_value:answers[key],question_number:qIndex(),question_count:questionCount(),time_on_question_seconds:Math.round((Date.now()-screenStartedAt)/1000)});setTimeout(goNext,240);});});
qs('[data-cpc-back]').addEventListener('click',goBack);
root.querySelectorAll('[data-unlock-analysis]').forEach(function(b){b.addEventListener('click',function(){track('CRC v4 - Unlock Clicked',Object.assign({value:197,currency:'USD',product_name:'Personal Credit Report Explanation'},resultData));idx=flow.indexOf('checkout');show();});});
root.querySelectorAll('[data-checkout-back]').forEach(function(b){b.addEventListener('click',function(){idx=flow.indexOf('result');show();});});
function cleanPhone(value){
  return String(value||'').replace(/[^\d+]/g,'').slice(0,20);
}

function collectCustomerData(){
  return {
    first_name:(qs('#coCpcFirstName').value||'').trim(),
    last_name:(qs('#coCpcLastName').value||'').trim(),
    email:(qs('#coCpcPaymentEmail').value||'').trim(),
    phone:cleanPhone(qs('#coCpcPaymentPhone').value),
    order_contact_consent:!!qs('#coCpcOrderContactConsent').checked,
    sms_consent:!!qs('#coCpcSmsConsent').checked,
    browser_timezone:(Intl.DateTimeFormat().resolvedOptions().timeZone||''),
    page_url:window.location.href,
    referrer:document.referrer||''
  };
}

function validateCustomerData(data){
  if(!data.first_name)return 'Please enter your first name.';
  if(!data.last_name)return 'Please enter your last name.';
  if(!data.email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email))return 'Please enter a valid email address.';
  if(!data.phone||data.phone.replace(/\D/g,'').length<10)return 'Please enter a valid mobile number.';
  if(!data.order_contact_consent)return 'Please authorize order-related communication to continue.';
  return '';
}

async function initStripeCheckout(){
  if(checkoutInitialized)return;
  var msg=qs('#coCpcPaymentMessage');

  try{
    if(!window.Stripe)throw new Error('Stripe did not load. Please refresh and try again.');

    customerData=collectCustomerData();
    var validationError=validateCustomerData(customerData);
    if(validationError)throw new Error(validationError);

    stripe=Stripe(STRIPE_PUBLIC_KEY);

    var metadata=Object.assign({
      funnel:'Credit Report Clarity Funnel',
      version:'CRC v4',
      first_name:customerData.first_name,
      last_name:customerData.last_name,
      customer_email:customerData.email,
      customer_phone:customerData.phone,
      order_contact_consent:String(customerData.order_contact_consent),
      sms_consent:String(customerData.sms_consent),
      browser_timezone:customerData.browser_timezone,
      diagnostic_answers:JSON.stringify(answers).slice(0,450),
      checkout_started_at:new Date().toISOString()
    },resultData);

    var payload={
      amount:19700,
      price:197,
      currency:'usd',
      product:'Personal Credit Report Explanation',
      product_name:'Personal Credit Report Explanation',
      success_url:SUCCESS_URL,
      customer:customerData,
      metadata:metadata
    };

    var res=await fetch(PAYMENT_INTENT_URL,{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(payload)
    });

    var data=await res.json().catch(function(){return{};});
    if(!res.ok)throw new Error(data.error||data.message||'Could not start checkout.');

    var clientSecret=data.clientSecret||data.client_secret||data.paymentIntentClientSecret;
    if(!clientSecret)throw new Error('Missing payment setup response.');

    orderData={
      order_reference:data.orderReference||data.order_reference||'',
      payment_intent_id:data.paymentIntentId||data.payment_intent_id||''
    };

    elements=stripe.elements({
      clientSecret:clientSecret,
      appearance:{
        theme:'stripe',
        variables:{
          colorPrimary:'#2F6B52',
          colorText:'#172744',
          borderRadius:'14px'
        }
      }
    });

    paymentElement=elements.create('payment',{
      defaultValues:{
        billingDetails:{
          name:(customerData.first_name+' '+customerData.last_name).trim(),
          email:customerData.email,
          phone:customerData.phone
        }
      }
    });

    paymentElement.mount('#coCpcPaymentElement');
    checkoutInitialized=true;
    qs('#coCpcPaymentStage').hidden=false;
    qs('#coCpcContinueToPayment').hidden=true;

    if(msg)msg.textContent='';

    track('CRC v4 - Checkout Viewed',Object.assign({},resultData,{
      sms_consent:customerData.sms_consent,
      order_reference:orderData.order_reference
    }));

    setTimeout(function(){
      qs('#coCpcPaymentStage').scrollIntoView({behavior:'smooth',block:'center'});
    },100);

  }catch(err){
    if(msg)msg.textContent=err.message||'Checkout could not load.';
    track('CRC v4 - Payment Failed',{
      stage:'checkout_init',
      error:(err&&err.message)||String(err)
    });
    throw err;
  }
}

var continueToPayment=qs('#coCpcContinueToPayment');
if(continueToPayment){
  continueToPayment.addEventListener('click',async function(){
    var msg=qs('#coCpcPaymentMessage');
    customerData=collectCustomerData();
    var validationError=validateCustomerData(customerData);

    if(validationError){
      if(msg)msg.textContent=validationError;
      return;
    }

    continueToPayment.disabled=true;
    continueToPayment.textContent='Preparing secure payment...';

    try{
      await initStripeCheckout();
    }catch(err){
      continueToPayment.disabled=false;
      continueToPayment.textContent='Continue to Secure Payment';
    }
  });
}

var form=qs('#coCpcPaymentForm');
if(form){
  form.addEventListener('submit',async function(e){
    e.preventDefault();

    var btn=qs('#coCpcPayButton');
    var txt=qs('#coCpcPayButtonText');
    var msg=qs('#coCpcPaymentMessage');

    customerData=collectCustomerData();
    var validationError=validateCustomerData(customerData);

    if(validationError){
      msg.textContent=validationError;
      return;
    }

    if(!stripe||!elements){
      msg.textContent='Please continue to secure payment first.';
      return;
    }

    btn.disabled=true;
    txt.textContent='Processing...';
    msg.textContent='';

    track('CRC v4 - Payment Submitted',Object.assign({
      value:197,
      currency:'USD',
      sms_consent:customerData.sms_consent,
      order_reference:orderData.order_reference||''
    },resultData));

    try{
      var uploadUrl=new URL(SUCCESS_URL);
      if(orderData.order_reference)uploadUrl.searchParams.set('order',orderData.order_reference);
      uploadUrl.searchParams.set('email',customerData.email);

      var result=await stripe.confirmPayment({
        elements:elements,
        confirmParams:{
          return_url:uploadUrl.toString(),
          receipt_email:customerData.email,
          payment_method_data:{
            billing_details:{
              name:(customerData.first_name+' '+customerData.last_name).trim(),
              email:customerData.email,
              phone:customerData.phone
            }
          }
        },
        redirect:'if_required'
      });

      if(result.error)throw new Error(result.error.message||'Payment could not be completed.');

      track('CRC v4 - Purchase Completed',Object.assign({
        value:197,
        currency:'USD',
        sms_consent:customerData.sms_consent,
        order_reference:orderData.order_reference||'',
        payment_intent_id:(result.paymentIntent&&result.paymentIntent.id)||orderData.payment_intent_id||''
      },resultData));

      idx=flow.indexOf('success');
      show();

      setTimeout(function(){
        window.location.href=uploadUrl.toString();
      },900);

    }catch(err){
      msg.textContent=err.message||'Payment failed. Please try again.';
      track('CRC v4 - Payment Failed',{
        stage:'confirm_payment',
        error:(err&&err.message)||String(err)
      });
      btn.disabled=false;
      txt.textContent='Get My Personal Credit Report Explanation — $197';
    }
  });
}

buildFlow(); show(); track('CRC v4 - Assessment Viewed',{stage:'inline_start'});
})();